import Select from "react-select";

const StayDetails = ({
    isStayEditMode,
    arrivalDate,
    setArrivalDate,
    departureDate,
    setDepartureDate,
    nights,
    rateTypeCode,
    setRateTypeCode,
    rateCodes,
    agentList,
    selectedAgentId,
    setSelectedAgentId,
    corporateList,
    selectedCorporateId,
    setSelectedCorporateId,
    handleStayEdit,
    handleStayCancel,
    handleStayDone,   
    handleSearchRoom,
}) => {
    return (
        <div className="row g-4 mb-4">
            <div className="col-lg-12">
                <div className="card h-100">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <div>
                            <span className="material-symbols-outlined me-2 text-primary">calendar_today</span>
                            Stay Details
                        </div>
                        <div className="d-flex gap-2">
                            {!isStayEditMode ? (
                                <button type="button" className="btn btn-sm btn-primary" onClick={handleStayEdit}>
                                    Edit
                                </button>
                            ) : (
                                <>
                                    <button className="btn btn-sm btn-success" type="button" onClick={handleStayDone}>Done</button>
                                    <button type="button" className="btn btn-sm btn-secondary" onClick={handleStayCancel}>Cancel</button>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-md-2">
                                <label className="form-label">Arrival Date</label>
                                {isStayEditMode ? (
                                    <input className="form-control" type="date" value={arrivalDate}
                                        onChange={(e) => setArrivalDate(e.target.value)} />
                                ) : (
                                    <div className="form-control-plaintext fw-semibold">{arrivalDate || "-"}</div>
                                )}
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">Departure Date</label>
                                {isStayEditMode ? (
                                    <input className="form-control" type="date" value={departureDate}
                                        min={arrivalDate} onChange={(e) => setDepartureDate(e.target.value)} />
                                ) : (
                                    <div className="form-control-plaintext fw-semibold">{departureDate || "-"}</div>
                                )}
                            </div>

                            <div className="col-md-1">
                                <label className="form-label">Nights</label>
                                <input className="form-control fw-bold text-primary bg-light" readOnly type="number" value={nights} />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label">Rate Code</label>
                                {isStayEditMode ? (
                                    <select className="form-select form-control" value={rateTypeCode}
                                        onChange={(e) => setRateTypeCode(e.target.value)}>
                                        <option value="">Select Type</option>
                                        {rateCodes.map((item, index) => (
                                            <option key={index} value={item.RateCodeType}>{item.RateCodeType}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <div className="form-control-plaintext fw-semibold">{rateTypeCode || "-"}</div>
                                )}
                            </div>

                            {rateTypeCode === "Travel Agent" && (
                                <div className="col-md-3">
                                    <label className="form-label">Travel Agent</label>
                                    {isStayEditMode ? (
                                        <Select
                                            options={agentList.map(agent => ({ value: agent.AgentID, label: agent.TA_Name }))}
                                            placeholder="Select Agent"
                                            value={agentList.map(agent => ({ value: agent.AgentID, label: agent.TA_Name }))
                                                .find(opt => opt.value === selectedAgentId)}
                                            onChange={(selected) => setSelectedAgentId(selected?.value)}
                                            isSearchable isClearable
                                        />
                                    ) : (
                                        <div className="form-control-plaintext fw-semibold">
                                            {agentList.find(agent => agent.AgentID === selectedAgentId)?.TA_Name || "-"}
                                        </div>
                                    )}
                                </div>
                            )}

                            {rateTypeCode === "Corporate" && (
                                <div className="col-md-3">
                                    <label className="form-label">Corporate</label>
                                    {isStayEditMode ? (
                                        <Select
                                            options={corporateList.map(corp => ({
                                                value: corp.CorporateID,
                                                label: `${corp.TA_Name} (CP_${corp.CorporateCode || "N/A"})`
                                            }))}
                                            placeholder="Select Corporate"
                                            value={corporateList.map(corp => ({
                                                value: corp.CorporateID,
                                                label: `${corp.TA_Name} (CP_${corp.CorporateCode || "N/A"})`
                                            })).find(opt => opt.value === selectedCorporateId)}
                                            onChange={(selected) => setSelectedCorporateId(selected?.value)}
                                            isSearchable isClearable
                                        />
                                    ) : (
                                        <div className="form-control-plaintext fw-semibold">
                                            {corporateList.find(corp => corp.CorporateID === selectedCorporateId)?.TA_Name || "-"}
                                        </div>
                                    )}
                                </div>
                            )}

                            {isStayEditMode && (
                                <div className="col-md-2">
                                    <div style={{ marginTop: "28px" }}>
                                        <button type="button" className="btn btn-primary" onClick={handleSearchRoom}>
                                            Change Date
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StayDetails;